import * as React from 'react';

import { Link, useLocation, useParams } from 'react-router-dom';
import { Routes } from 'constants/pages';

import { Container } from 'types/Watchlist';
import { Permission, useHasPermission } from 'utils/permissions';
import { SelectedContainerContext } from '../../../contexts/SelectedContainerContextProvider';
import { CellProps } from './types';
import { Cell } from './Cell';

export const ContainerCell: React.FC<CellProps> = (params) => {
  const container: Container = params.row;

  const { containerNumber, shippingLine, containerType } = container;
  const { gatedIn, gatedOut } = container;
  const portRegionInitials =
    gatedIn?.portName || gatedOut?.portCode || container.pickupInfo?.portCode;

  // Determine whether this container is selected
  const urlParams = useParams();
  const isSelected = urlParams.containerNumber === containerNumber;
  const [, setSelectedContainer] = React.useContext(SelectedContainerContext);
  const { search } = useLocation();

  // Some users may not track
  const accessPickupTrackChanges = useHasPermission([Permission.TrackNTracePickupTrackChanges]);
  const numberLabel = accessPickupTrackChanges ? (
    <Link
      to={`${Routes.ContainerTracking}/${containerNumber}${search}`}
      // container-link is important for allowing seamless navigation between containers in the details view
      className="cursor-pointer text-blue-900 underline container-link"
      onClick={() =>
        setSelectedContainer({
          watchListRow: params.row,
          return: window.location.search,
        })
      }
    >
      {containerNumber}
    </Link>
  ) : (
    containerNumber
  );

  return (
    <Cell
      className={`flex flex-col items-center space-y-2 ${
        isSelected ? 'border-2 border-blue-900' : ''
      } overflow-hidden`}
    >
      <h5 className="font-bold">{numberLabel}</h5>
      <h5 className="break-words whitespace-normal text-center">
        {shippingLine || '-'} {shippingLine ? '·' : ''} {containerType || '-'}
      </h5>
      {portRegionInitials && (
        <h5 className="text-gray-800 bg-gray-100 rounded px-1">{portRegionInitials}</h5>
      )}
    </Cell>
  );
};
ContainerCell.displayName = 'ContainerTable.ContainerCell';
